export default __webpack_public_path__ + "static/media/payNowIcon.c2232817.svg";